// The type of expand in work orders list
export enum ExpandTypeState {
  WORK_ORDER_LEVEL = 'Collapse All',
  TRIP_LEVEL = 'Trips',
  VISIT_LEVEL = 'Trips, Visits',
  SERVICES_TASKS_LEVEL = 'Trips, Visits, Services & Tasks'
}
